// extracted by mini-css-extract-plugin
export default {"AnimatedHide":"AnimatedHide_AnimatedHide__VFwUX","AnimatedHide__isClosed":"AnimatedHide_AnimatedHide__isClosed__Gt2WT"};